module.exports = __webpack_public_path__ + "static/media/codetocompete.3b394da5.jpeg";